<template>
  <div class="force_update_parent">
    <div class="force_update_content">
      <div class="contentTitle">{{ forceUpdateTitleLabel }}</div>
      <div class="force_update_inner">
        <div class="force_update_info" v-html="forceUpdateInfo"></div>
        <div>
          <div>{{ iOS }}</div>
          <div class="force_update_input_area">
            <div>{{ ver }}</div>
            <input
              id="ver_ios"
              type="text"
              v-model="versionIOS"
              class="force_update_input_field"
              placeholder="1.0"
            />
          </div>
        </div>
      </div>
      <input
        type="button"
        :value="update"
        class="force_update_update_button"
        @click="checkFormat"
      />
    </div>
    <div class="modal_window" v-if="showConfirmModal">
      <confirmCustomTitleModalWindow
        :title="confirmModalTitle"
        :question="confirmModalQuestion"
        @close="close"
        @ok="updateVersion"
      >
      </confirmCustomTitleModalWindow>
    </div>
    <div class="complete_modal_window" v-if="showFailureModal">
      <completeModalWindow :question="failureWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="complete_modal_window" v-if="showCompleteModal">
      <completeModalWindow :question="completeWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import confirmCustomTitleModalWindow from '../modalWindow/confirmCustomTitleModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      forceUpdateTitleLabel: '強制アップデート',
      forceUpdateInfo:
        'アプリの有効バージョンを更新できます。<br/>設定したバージョン未満だとアプリ内にアップデートを求めるポップアップを表示します。',
      iOS: 'iOS',
      ver: 'ver',
      verPlaceholder: '1.0',
      update: '更新',
      confirmModalTitle: '強制アップデート',
      confirmModalQuestion:
        'ストアに最新版が配信されていることを確認の上更新してください。',
      failureWord:
        'バージョンのフォーマットが正しくありません。<br/>半角数字で「x.x」の形で入力してください。',
      completeWord: '変更しました。',
      showConfirmModal: false,
      showFailureModal: false,
      showCompleteModal: false,
      showloadingModal: false
    }
  },
  computed: {
    versionIOS() {
      return this.$store.state.forcedUpdate.versionIOS
    },
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    }
  },
  components: {
    confirmCustomTitleModalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.dispatch('systemAdminDefine/clearCompanyInfo')
    this.showloadingModal = true
    try {
      await this.$store.dispatch('forcedUpdate/setVersion')
    } catch (error) {
      let eventNumber = this.$store.state.error.sysErrorCode.sysErrorCode_680001
      this.createErrorMessage(error, eventNumber, 'MSGCRD0108')
      this.showFailureModal = true
    }
    this.showloadingModal = false
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    checkFormat() {
      // フォーマットチェック
      let verIos = document.getElementById('ver_ios').value
      this.$store.dispatch('forcedUpdate/inputVersion', verIos)
      if (typeof verIos === 'string' && /^(\d+)\.(\d+)$/.test(verIos)) {
        this.showConfirmModal = true
      } else {
        this.showModal = false
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_680001
        let reason = 'MSGCRD0102'
        let eventType = 9
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0102.name +
          this.sysErrorMsg.MSGCRD0102.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
      }
    },
    async updateVersion() {
      this.showConfirmModal = false
      this.showloadingModal = true
      let verIos = document.getElementById('ver_ios').value
      try {
        await this.$store.dispatch('forcedUpdate/updateVersion', {
          versionIOS: verIos
        })
        this.completeWord = '変更しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber =
          this.$store.state.error.sysErrorCode.sysErrorCode_680001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0108')
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
    close() {
      this.showConfirmModal = false
      this.showFailureModal = false
      this.showCompleteModal = false
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/forcedUpdate/forcedUpdate.vue